import api from './base/standardApi';

export default {
  getAdminInvitations( params: any ) {
    return api.get( 'api/invitaciondescarga/GetAll', params );
  },
  deleteAdminInvitation( id: number ) {
    return api.delete( `api/invitaciondescarga/Delete/${id}` );
  },
  getAdminInvitationsDocuments() {
    return api.get( 'api/invitaciondescarga/GetAllDocuments' );
  },
  getAdminInvitationsById( id:number ) {
    return api.get( `api/invitaciondescarga/GetById/${id}` );
  },
  getAdminGetDocumentNdaById( id:number ) {
    return api.get( `api/invitaciondescarga/GetDocumentNdaById/${id}` );
  },
  getDownloadDocumentAsAdmin( invitacionUid: string, documentoUid: string ) {
    return api.get( 'api/invitaciondescarga/DownloadDocumentAsAdmin', {
      InvitacionUid: invitacionUid,
      DocumentoUid: documentoUid,
    } );
  },
  createAdminInvitationsDocuments( data:any ) {
    return api.post( 'api/invitaciondescarga/CompartirDocumentos', data );
  },
  startValidateDocuments( data: {
    carpetasPaths: string[];
    documentosIds: number[];
    type?: string;
  } ) {
    return api.post( 'api/invitaciondescarga/ValidarDocumentosPropuesta', data );
  },
  getValidateDocumentsStatus( validacionId: string ) {
    return api.get( 'api/invitaciondescarga/ValidarDocumentosStatus', { validacionId } );
  },
  updateAdminInvitationsDocuments( data:any ) {
    return api.put( 'api/invitaciondescarga/CompartirDocumentos', data );
  },
};
